/* eslint-disable global-require */
/* eslint-disable import/no-unresolved */
const processInclude = require('base/util');
const productCompare = require('onestic-base/product/compare');
const search = require('./search/search');
const priceSlider = require('onestic-base/search/priceSlider');
const relatedProducts = require('onestic-base/product/components/featuredProductViewCarousel');
const quickShopping = require('./components/quickShopping').assignQuickShopping;
const videoPlayer = require('onestic-base/components/videoPlayer');
const backHistory = require('onestic-base/search/backHistory');

let categoryDatalayer;
let initialDatalayer;

if (window.dataLayer) {
    if (window.datalayerVersion === 'universal') {
        categoryDatalayer = require('plugin-seo/universalDataLayer/layers/category');
    } else {
        categoryDatalayer = require('plugin-seo/dataLayerGA4/layers/category');
        initialDatalayer = require('plugin-seo/dataLayerGA4/layers/globalData');
    }
} else {
    const globalDataCode = require('plugin-seo/dataLayerGA4/layers/globalData');
    window.dataLayer = [];
    globalDataCode.sentInitConsent();
    globalDataCode.collectConsentTrackingInfo();
}

function processRequires() {
    processInclude(search);
    processInclude(productCompare);
    processInclude(relatedProducts);
    processInclude(quickShopping);
    processInclude(priceSlider);
    processInclude(videoPlayer);

    if (window.dataLayer) {
        processInclude(initialDatalayer);
        processInclude(categoryDatalayer);
    }
    backHistory.moveScrollBackInHistory();
}


$(document).ready(() => {
    const performance = window.performance.getEntriesByType('navigation');
    let eventType;
    if (typeof performance === 'object' && performance.length) {
        eventType = performance[0].type;
    }
    const environmentAvailable = $('#isDynamic').attr('data-available');
    $.spinner().start();
    if (eventType === 'back_forward' && environmentAvailable === 'true') {
        const promise = backHistory.backInHistory();
        promise.done((response) => {
            if (response.redirectURL) {
                window.location.href = response.redirectURL;
            } else {
                processRequires();
            }
        });
    } else {
        processRequires();
    }
});

require('base/components/spinner');
